export enum EStatus {
  Blocked = 'blocked',
  Deactivated = 'deactivated',
  Deleted = 'deleted',
  Draft = 'draft',
  Merge = 'merge',
  Moderate = 'moderate',
  New = 'new',
  Published = 'published',
  Refused = 'refused',
  RemovedByModerator = 'removedByModerator',
  Sold = 'sold',
}

export enum EOrderField {
  Added = 'added',
  Created = 'created',
  Price = 'price',
}

export enum EEntityType {
  Commercial = 'commercial',
  Newbuilding = 'newbuilding',
  Residential = 'residential',
  Suburban = 'suburban',
}

export enum EDealType {
  Rent = 'rent',
  Sale = 'sale',
}

export enum EFavoriteEntityType {
  Flat = 'flat',
  Suburban = 'suburban',
  Commercial = 'commercial',
  JK = 'JK',
}

export interface IFiltersState {
  dealType: EDealType | null;
  favoriteEntityType: EEntityType | null;
  orderField?: EOrderField | null;
  showFiltersModal?: boolean;
}
